import React from 'react';
import { DSSheet, DSButton, DSAlert } from '../design-system/primitives';

// Bottom-sheet confirm flow for a member undoing their own task completion.
// Uses DSSheet rather than the local tm-sheet-* markup it carried before, so it
// picks up the design system's sheet behaviour (escape to close, safe-area padding,
// centred layout from 640px up) instead of reimplementing a subset of it.
function UndoConfirmSheet({ pointValue, onConfirm, onCancel, submitting }) {
  return (
    <DSSheet
      title="Undo Completion"
      onClose={onCancel}
      footer={
        <>
          <DSButton appearance="outline" tone="neutral" onClick={onCancel} disabled={submitting}>
            Keep it, cancel
          </DSButton>
          <DSButton appearance="solid" tone="danger" onClick={onConfirm} disabled={submitting}>
            {submitting ? 'Undoing...' : 'Yes, Undo Completion'}
          </DSButton>
        </>
      }
    >
      <DSAlert variant="warning">
        Undoing will deduct {pointValue} point{pointValue === 1 ? '' : 's'} from your total
        and return the task to the open pool.
      </DSAlert>
    </DSSheet>
  );
}

export default UndoConfirmSheet;
